import { Component} from '@angular/core';

@Component({
  selector: 'app-blankview',
  templateUrl: './blankview.component.html',
  styleUrls: ['./blankview.component.scss'],
})
export class BlankviewComponent {
 


   
}
